// extracted by css-extract-rspack-plugin
export default {"tools-Layout":"tools-Layout-FhQDGq","toolsLayout":"tools-Layout-FhQDGq"};